<div class="row" *ngIf="contractDetails">
    <div class="col-6">
        <h1>Contrato: {{ contractId }}</h1>
    </div>
    <div class="col-6 ">
    <div style="text-align: right" *ngIf="contractDetails.active == 1">
        <a (click)="downloaded()" [href]="fileUrl" class="btn btn-primary" download="{{ fileName }}.pdf">Descargar Contrato</a>
    </div>
    </div>
</div>

<div class="row" *ngIf="contractDetails">
    <div class="col-md-4">
        <div class="card form-container">
            <form [formGroup]="contractForm" *ngIf="contractForm && contractDetails.active == 1">
                <fieldset disabled>
                <div class="form-group">
                    <label class="form-labels mt-4">Enviar recordatorio e información por mensajes de texto</label><br/>
                    <div class="form-check form-check-inline mt-2">
                        <input class="form-check-input" type="radio"  value="si" formControlName="textMsgNotification">
                        <label class="form-check-label">Si</label>
                        </div>
                        <div class="form-check form-check-inline">
                        <input class="form-check-input" formControlName="textMsgNotification" type="radio" value="no">
                        <label class="form-check-label">No</label>
                    </div>
                </div>

                <div class="form-group">
                    <label class="form-labels mt-3">% Anual</label><br/>
                    <div class="form-check form-check-inline mt-2">
                        <input class="form-check-input" type="radio" value="si" formControlName="showAnualInterest">
                        <label class="form-check-label">Si</label>
                        </div>
                        <div class="form-check form-check-inline">
                        <input class="form-check-input" formControlName="showAnualInterest" type="radio" value="no">
                        <label class="form-check-label">No</label>
                    </div>
                </div>

                
                    <div class="form-group">
                        <label class="form-labels mt-3">Pago directo</label><br/>
                        <div class="form-check form-check-inline mt-2">
                            <input class="form-check-input" type="radio" value="si" formControlName="automaticDebit" (change)="updateAutomaticDebit()">
                            <label class="form-check-label">Si</label>
                            </div>
                            <div class="form-check form-check-inline">
                            <input class="form-check-input" formControlName="automaticDebit" type="radio" value="no" (change)="updateAutomaticDebit()">
                            <label class="form-check-label">No</label>
                        </div>
                    </div>

                    <div *ngIf="automaticDebitStatus">
                    <div class="form-group">
                        <label class="form-labels mt-3">Institución</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="bankInstName">
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="form-labels mt-3">Tipo de cuenta</label>
                        <select formControlName="accountType" class="form-select" (change)="updateAccountType()">
                            <option value="cheque">Cheque</option>
                            <option value="ahorro">Ahorro</option>
                            <option value="credito">Credito</option>
                        </select>
                    </div>

                    <div *ngIf="accountTypeStatus == 'cheque' || accountTypeStatus == 'ahorro'">
                        <div class="form-group">
                            <label class="form-labels mt-3">Ruta o Tránsito</label>
                            <div class="input-group">
                                <input type="text" class="form-control" formControlName="bankInstRoutingNum">
                            </div>
                        </div>
    
                        <div class="form-group">
                            <label class="form-labels mt-3"># de cuenta</label>
                            <div class="input-group">
                                <input type="text" class="form-control" formControlName="accountNumber">
                            </div>
                        </div>
                    </div>

                    <div *ngIf="accountTypeStatus == 'credito'">
                        <div class="form-group">
                            <label class="form-labels mt-3">Tipo de tarjeta</label>
                            <select formControlName="cardType" class="form-select">
                                <option value="Visa">Visa</option>
                                <option value="Master Card">Master Card</option>
                                <option value="American Express">American Express</option>
                                <option value="Discover">Discover</option>
                                <option value="Diners">Diners</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label class="form-labels mt-3"># de tarjeta</label>
                            <div class="input-group">
                                <input type="text" class="form-control" formControlName="cardNumber">
                            </div>
                        </div>
    
                        <div class="form-group">
                            <label class="form-labels mt-3">Fecha de expiración</label>
                            <div class="input-group">
                                <input type="text" class="form-control" formControlName="cardExp" [brmasker]="{mask: '00 / 0000', type:'num'}" maxlength="9">
                            </div>
                        </div> 
                    </div>

                     
                </div>
                </fieldset>
            </form>
            <div class="card-body" style="text-align: center;">
                <button [disabled]="true || contractDetails.paid" *ngIf="contractDetails.active == 1" type="button" class="btn btn-secondary" (click)="contractRefresh()" >
                    <span style="font-size: 25px; line-height: 20px;">⟳</span> Actualizar
                </button>
                <hr/>
                <button *ngIf="role == 'admin' && contractDetails.active == 1" type="button" class="btn btn-info" [disabled]="contractDetails.paid" (click)="editContract()">Editar contrato</button>
                <!-- TODO: WORK ON UPDATE FUNCTIONALITY -->
                <!-- <button *ngIf="role == 'producer' && contractDetails.active == 1 && !contractDetails.downloaded" type="button" class="btn btn-info" (click)="editContract()">Editar contrato</button> -->
                 <!-- TODO: WORK ON UPDATE FUNCTIONALITY -->
                <app-cancel-contract [contractData]="contractDetails"></app-cancel-contract>
                <app-delete-contract [contractData]="contractDetails"></app-delete-contract>
                <app-paid-contract [contractData]="contractDetails"></app-paid-contract>
                <app-completed-contract [contractData]="contractDetails"></app-completed-contract>
                
                <!-- <button type="button" class="btn btn-success" data-toggle="modal" aria-label="Left Align" data-target="#paidContractModal">
                    <span>
                        Marcar contrato pagado
                    </span>

                    
                </button> -->


            </div>
        </div>
    </div>
    <div class="col-md-8">
        <div class="card">
            <div class="card-body">
                <!-- <div class="language-selector">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="es" checked [(ngModel)]="language" (change)="updateLanguage($event)">
                        <label class="form-check-label" for="exampleRadios1" >
                          Español
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="en" [(ngModel)]="language" (change)="updateLanguage($event)">
                        <label class="form-check-label" for="exampleRadios2">
                          Ingles
                        </label>
                      </div>
                </div> -->
                <pdf-viewer  id="pdf-preview" [original-size]="false" [fit-to-page]="true"  [src]="pdfView" ></pdf-viewer>
            </div>
        </div>
    </div>
</div>

<div class="row" *ngIf="contractDetails" >
    <div class="col-md-12" *ngIf="contractDetails.active == 1">
      <div class="card">
        <div class="card-header">
            <div class="row align-items-center card-header">
                <div class="col-12">
                    <h5>Pagos <button class="btn btn-primary" [disabled]="installments?.length <= 0" style="float: right;" routerLink="/pay-book/{{contractDetails.id}}">Cupones de pago</button></h5>
                </div>
                <!-- <div class="col-6">
                    <div style="text-align: right" *ngIf="contractDetails.active == 1 && installmentsCreated == false">
                        <a (click)="generatePayments()" class="btn btn-primary" >Generar Pagos</a>
                    </div>
                </div> -->
            </div>
        </div>
          <div class="card-body">
            <div class="table-responsive">
                <table class="table">
                <thead>
                    <tr>
                    <th scope="col">Contracto</th>
                    <th scope="col"># pago</th>
                    <th scope="col">Cantidad</th>
                    <th scope="col">Fecha de pago</th>
                    <th scope="col">Referencia</th>
                    <th scope="col">Status</th>
                    <th scope="col" *ngIf="role == 'admin'"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let installment of installments">
                    <td>{{ installment.idContract }}</td>
                    <td>{{ installment.installmentNumber }}</td>
                    <td>{{ installment.installmentAmount | currency }}</td>
                    <td>{{ installment.installmentDate | date:'short'  }}</td>
                    <td>{{ installment.reference }}</td>
                    <td *ngIf="installment.paid"><span style="color: green;">Pagado</span></td>
                    <td *ngIf="!installment.paid"><span style="color: red;">Pendiente</span></td>
                    <td *ngIf="role == 'admin'"><button type="button" (click)="markPaid(installment)" class="btn btn-secondary" data-toggle="modal" data-target="#editPayModal">Editar</button></td>
                    </tr>
                </tbody>
                </table>
            </div>
          </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="contractDetails" >
    <div class="col-md-12" *ngIf="role == 'admin' && contractDetails.active == 1">
      <div class="card">
        <div class="card-header">
            <div class="row align-items-center card-header">
                <div class="col-6">
                    <h5>Notas</h5>
                </div>
                <div class="col-6">
                    <div style="text-align: right">
                        <a (click)="updateNotes()" class="btn btn-primary" >Guardar</a>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <textarea class="form-control" [(ngModel)]="notes" rows="5" ></textarea>
                </div>
            </div>
        </div>
      </div>
    </div>
   </div>
  <app-edit-payment [installmentData]="installmentEdit"></app-edit-payment>

<div *ngIf="loading" class="d-flex justify-content-center loading-screen">
  <div class="spinner-border" role="status">
    <span class="sr-only"></span>
  </div>
</div>
